import {useDispatch, useSelector} from "react-redux";
import React, {useState} from "react";
import {reCalculate, setAdditionalServices, setInstallation} from "../../core/redux/ActionCreator";
import {Divider} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import {priceFormat} from "../../shared/util/util";

function DealerServices() {
    const dispatch = useDispatch();

    let addService = false;
    let selectedItems = useSelector(state => state.cartReducer.cart);
    let [updateCart, setUpdateCart] = useState(false);
    const updateQuantity = useSelector(state => state.cartReducer.updateQuantity);
    const dealerServices = useSelector(state => state.dealerReducer.dealerServices);
    const serviceOptions = useSelector(state => state.dealerReducer.serviceOptions);

    if (updateQuantity) {
        setUpdateCart(true);
    }

    if (updateCart) {
        dispatch(reCalculate({updateQuantity: false}));
    }

    if (serviceOptions.length !== 0) {
        addService = true;
    }

    const installTires = selectedItems.map((value, index) => (
        <div className={"grid"} key={index}>
            <Grid container spacing={1} >
                <Grid item xs={9} md={9} alignItems={'flex-end'} >
                    <Checkbox checked={value.installation} onChange={() => isChecked(index)}
                              name={value.name} className={'stat-checkbox'} data-dtm={'cart:summary:installation'}/>
                    <span className={"serviceName"}>{value.name}</span>
                </Grid>
                <Grid  item xs={3} md={3}>
                    {value.runflat ?
                        <div className={'serviceCost'}>
                            <CalculateInstall gmPartNum={value.gmPartNum}
                                              price={dealerServices.tireOptions.installationRunflat}/>
                        </div>
                        : <div className={'serviceCost'}>
                            <CalculateInstall gmPartNum={value.gmPartNum}
                                              price={dealerServices.tireOptions.installation}/>
                        </div>
                    }
                </Grid>
            </Grid>
        </div>
    ));

    const isChecked = (event) => {
        dispatch(setInstallation({tireIndex: event}));
    };

    const addServices = (index) => {
        dispatch(setAdditionalServices({serviceIndex: index}));

        if(serviceOptions[index].name.includes('Alignment')){
            if(serviceOptions[index].isChecked){
                serviceOptions.forEach(service => {if(service.name !== serviceOptions[index].name && service.name.includes('Alignment')){
                    service.isDisabled = true;
                }})
            }else{
                serviceOptions.forEach(service => {if(service.name !== serviceOptions[index].name && service.name.includes('Alignment')){
                    service.isDisabled = false;
                }})
            }
        }
    };

    const services = serviceOptions.map((value, index) => (
        <div className={"grid"} key={index}>
            {!value.isDisabled &&
            <Grid container spacing={1} >
                <Grid item xs={9} md={9} alignItems={'flex-end'} >
                    <Checkbox checked={value.isChecked} onChange={() => addServices(index)}
                              name={value.name} className={'stat-checkbox'} data-dtm={'cart:summary:services'}/>
                    <span className={"serviceName"}>{value.name}</span>
                </Grid>
                <Grid item xs={3} md={3}>
                    <div className={'serviceCost'}>
                        <PerTire price={value.price} perTire={value.perTire}/>
                    </div>
                </Grid>
            </Grid>}
        </div>
    ));

    function PerTire({price, perTire}){
        if(!perTire){
            return priceFormat(1 * price)
        }else{
            return <GetTires price={price}/>;
        }
    }

    function GetTires({price}){
        const ResultCart = useSelector(state => state.cartReducer.cart);
        let quantityValue = 0;
        ResultCart.forEach((tire) => {
            quantityValue = quantityValue +tire.quantity;
        });
        return priceFormat(quantityValue * price)
    }

    function CalculateInstall ({gmPartNum, price}){
        const ResultCart = useSelector(state => state.cartReducer.cart);
        let quantityValue = 1;
        ResultCart.forEach((tire) => {
            if(tire.gmPartNum === gmPartNum){
                quantityValue = tire.quantity;
            }});
        return priceFormat(quantityValue * price)
    }

    function SubTotal(){
        let additionalServiceTotal = 0;
        let installTotal = 0;
        let tireTotal = 0;
        let mailInRebate = 0;
        let buyThreeGetOne = 0;
        let numberOfTire = 0;
        let contactDealer = false;
        const salesTaxPercentage = dealerServices.tireOptions.taxPercentage;
        const installTaxPercentage = dealerServices.tireOptions.installationTax;
        const installRunflatTaxPercentage = dealerServices.tireOptions.installationRunflatTax;
        let taxAmount = 0;
        let additionalServiceTaxAmount = 0;

        selectedItems.forEach((value) => {
            let tireSubtotal = (value.quantity * value.price);
            tireTotal += tireSubtotal;
            numberOfTire = value.quantity;
            taxAmount += tireSubtotal * salesTaxPercentage;

            if (value.offerType === "M") {
                if (value.quantity >= 4) mailInRebate += value.rebateAmtPerFourTires;
            }
            if (value.offerType === "B") {
                if (value.quantity >= 4) buyThreeGetOne = value.price - 1;
            }

            if (value.priceFailed) contactDealer = true;

            let installSubtotal = 0;
            if (value.runflat && value.installation) {
                installSubtotal = value.quantity * dealerServices.tireOptions.installationRunflat;
                installTotal += installSubtotal;
                taxAmount += installSubtotal * installRunflatTaxPercentage;
            } else if (value.installation) {
                installSubtotal = value.quantity * dealerServices.tireOptions.installation;
                installTotal += installSubtotal;
                taxAmount += installSubtotal * installTaxPercentage;
            }
        });

        serviceOptions.forEach((service) => {
            let additionalServiceSubtotal = 0;
            if (service.isChecked) {
                additionalServiceSubtotal = (service.perTire ? (numberOfTire * service.price) : service.price);
                additionalServiceTotal += additionalServiceSubtotal;
                additionalServiceTaxAmount += additionalServiceSubtotal * service.tax;
            }
        });

        const subTotal = (tireTotal + installTotal + additionalServiceTotal);
        const tax = taxAmount + additionalServiceTaxAmount;
        const calculatedTotal = subTotal + tax - mailInRebate - buyThreeGetOne;

        return (
            <div>{contactDealer
               ?<Grid>
                        <div className={'contactDealer'}>Contact Dealer for pricing</div>
                </Grid>
               : <Grid container spacing={2}>
                    <Grid item xs={6} md={6}>
                        <div className={'subtotalsLeft'}>Sub-Total</div>
                        <div className={'subtotalsLeft'}>Sales Tax(May apply)</div>
                        {mailInRebate !== 0 ? <div className={'subtotalsLeft'}>Mail-in Rebate</div> : null}
                        {buyThreeGetOne !== 0 ? <div className={'subtotalsLeft'}>Buy 3 Instant Offer</div> : null}
                        <div className={'totalLeft'}>Total</div>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <div className={'subtotalsRight'}>{priceFormat(subTotal)}</div>
                        <div className={'subtotalsRight'}>{priceFormat(tax)}</div>
                        {mailInRebate !==0 ? <div className={'subtotalsRight'}>{priceFormat(mailInRebate * -1)}</div>:null}
                        {buyThreeGetOne !== 0 ? <div className={'subtotalsRight'}>{priceFormat(buyThreeGetOne * -1)}</div>:null}
                        <div className={'totalRight'}>{priceFormat(calculatedTotal)}</div>
                    </Grid>
                </Grid>}
            </div>);
    }

    return <>
        <div className='installation'>
            <div>
                <h3>Installation</h3>
                <br/>
                {installTires}
                <br/>
                {addService && (
                    <>
                        <h3>Additional Services</h3>
                        <br/>
                        {services}
                    </>)}
                <br/>
                <br/>
                <Divider/>
                <br/>
                <SubTotal/>
            </div>
        </div>
    </>

}
export default DealerServices;
